var cnpjMask = function cnpjMask(value) {
  try {
    return value.replace(/\D+/g, '').slice(0, 14).replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
  } catch (_unused) {
    return '';
  }
};
export default cnpjMask;